import { cva } from "class-variance-authority";

const toggleVariants = cva(
  `
    inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium
    transition-colors
    hover:bg-black/5 hover:text-foreground/45
    focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-none
    focus-visible:ring-inset
    disabled:pointer-events-none disabled:opacity-50
    data-[state=on]:bg-accent data-[state=on]:text-accent-foreground
    [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0
  `,
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: `
          rounded-none bg-transparent
          first:rounded-l-md
          last:rounded-r-md
          hover:bg-accent hover:text-accent-foreground
        `,
      },
      size: {
        default: "h-9 min-w-9 px-2",
        xs: `
          h-6 min-w-6 px-1.5 text-xs
          [&_svg]:size-3.5
        `,
        sm: "h-8 min-w-8 px-1.5",
        lg: "h-10 min-w-10 px-2.5",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export { toggleVariants };
